import * as React from 'react'; // source: reach-ui
// https://github.com/reach/reach-ui/blob/master/packages/utils/src/index.tsx#L184

export function createNamedContext(name, defaultValue) {
  var context = /*#__PURE__*/React.createContext(defaultValue);
  context.displayName = name;
  return context;
}